import React from 'react';
import BaseClass from '@/pages/BaseClass';
import moment from 'moment';

import {
	Table,
	DatePicker,
	Form,
	Select,
	Input,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost,
	formatTime,
} from '@/utils/Tools';

const {Option} = Select;
const {Column,ColumnGroup} = Table;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'statusList':{},
			'methodList':{},
			
			'list':[],
			'pageInfo':{
				'current':1,
				'total':100,
				'pageSize':10,
			},
		};
	}
	
	componentDidMount()
	{
		this.getList();
		this.getStatusList();
	}
	
		
	getList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('charge','index');
		let param = this._parseFilter(this.filterForm.getFieldsValue());
		param['page'] = page;
		param['page_size'] = pageSize;
		
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info'].total,
						'pageSize':pageSize,
					},
				});
			});
	}
	
	_parseFilter(filter)
	{
		if(filter.time && filter.time.length)
		{
			filter['start_time'] = moment(filter.time[0]).format('YYYY-MM-DD');
			filter['end_time'] = moment(filter.time[1]).format('YYYY-MM-DD');
			delete(filter.time);
		}
		return filter;
	}
	
	getStatusList()
	{
		let url = pcUrl('charge','statusList');
		httpPost(url)
			.then(data=>{
				this.setState({
					'statusList':data['status_list'],
					'methodList':data['method_list'],
				});
			});
	}
	
	render()
	{
		return (
			<>
				<div className="filter">
					<Form layout="inline" ref={e=>this.filterForm=e} onFinish={(data)=>this.getList()}>
						<Form.Item name="time">
							<DatePicker.RangePicker />
						</Form.Item>
						<Form.Item name="status">
							<Select allowClear placeholder="选择充值状态" style={{'width':'12em'}}>
								{Object.keys(this.state.statusList).map(key=>(
								<Option value={key}>{this.state.statusList[key]}</Option>
								))}
							</Select>
						</Form.Item>
						<Form.Item name="keywords">
							<Input allowClear={true} style={{'width':'12em'}} placeholder="充值序号或金额" />
						</Form.Item>
						<Form.Item name="">
							<button className="button button-green">
								<span className="fa fa-search"></span>
								&nbsp;
								搜索
							</button>
						</Form.Item>
					</Form>
				</div>
				<Table pagination={{...this.state.pageInfo,'onChange':(page)=>this.getList(page)}} dataSource={this.state.list}>
					<Column title="充值序号" dataIndex="charge_sn" />
					<Column title="充值金额" dataIndex="charge_amount" />
					<Column title="入账金额" dataIndex="income_amount" />
					<Column title="状态" dataIndex="status" render={(text,row,index)=>{
						if(row['status'] != 1)
							return this.state.statusList[row['status']];
						else
							return (
								<>
									<span>{this.state.statusList[row['status']]}</span>
									<span>（{this.state.methodList[row['method']]}）</span>
								</>
							);
					}} />
					<Column title="操作时间" dataIndex="add_time" render={(text,row,index)=>{
						if(row['status'] != 1)
							return formatTime('Y-m-d H:i:s',row['add_time']);
						else
							return formatTime('Y-m-d H:i:s',row['charge_time']);
					}}/>
				</Table>
			</>
		);
	}
}



